import { IAppState } from 'shared/common/state';

export function selectBookingExistsModalOpened(state: IAppState) {
  return state.newbuildingBrokerCallbackWidget.bookingExistsModalOpened;
}
